export default __webpack_public_path__ + "static/media/reduce-bill.e9237d86.png";